import { KeyStructuredStorageBaseHelper } from './KeyStructuredStorageBaseHelper';
export class DeleteStructuredStorageHelper extends KeyStructuredStorageBaseHelper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.getKeyStructuredStorage({ type: this.type, keyType: this.keyType, knownKeyType: this.knownKeyType }));
        sb.emitHelper(node, optionsIn, sb.helpers.deleteStorage);
        if (optionsIn.pushValue) {
            sb.emitHelper(node, options, sb.helpers.wrapBoolean);
        }
    }
}

//# sourceMappingURL=DeleteStructuredStorageHelper.js.map
